<template>
  <div class="home-index wrapper">
    <div class="index-item">
      <div class="item-lf">
        <div class="lf-title">入读匈牙利名校 
          <div class="title-icons">
            <i class="lf-icon previous" @click="previousSchools"></i>
            <i class="lf-icon" @click="nextSchools"></i>
          </div>
        </div>
        <div class="lf-list">
          <!-- <i class="list-icon previous" @click="previousSchools"></i>
          <i class="list-icon next" @click="nextSchools"></i> -->
          <div class="list-info" v-for="(item, index) in schoolsList" :key="index" @click="goPage('/university/details', item.id)">
            <img class="list-img" :src="item.logo" alt="">
            <div class="list-text">
              <p class="text-self">{{ item.cn_name }}</p>
              <p class="text-self te">{{ item.en_name }}</p>
            </div>
          </div>
        </div>
        <!-- <div class="lf-pagination">
          <div class="pagination-btn" @click="previousSchools">上一页</div>
          <div class="pagination-btn" @click="nextSchools">下一页</div>
        </div> -->
      </div>
      <div class="item-rig">
        <div class="rig-logo">
          <img class="logo-img" src="~@/assets/images/top-logo.png" alt="">
        </div>
        <div class="rig-text">
          <p class="text-self">匈牙利留学合作中心隶属于中匈教育科技（南京）有限公司，是匈牙利校长委员会（Hungarian Rectors' Conference）在亚洲地区授权设立的官方代表处。作为中国早期开展匈牙利教育推广的专业机构，本公司获匈牙利多所高校授权，担任其在华唯一指定官方代表处及媒体运营中心。</p>
          <p class="text-self">本公司核心使命在于引进匈牙利优质高等教育资源，构建中匈教育合作战略平台，推进中匈校际深度合作项目，促进两国师资学术交流与学生互访。始终致力于成为中匈教育文化交流的桥梁与纽带，为两国教育合作事业贡献力量。</p>
        </div>
      </div>
    </div>
    <div class="index-item">
      <div class="item-lf">
        <p class="lf-title">录取捷报</p>
        <client-only>
          <el-table :data="successCasesList" style="width: 100%" height="250">
            <el-table-column prop="student_name" label="学生" align="center"></el-table-column>
            <el-table-column prop="product_school" label="录取院校" align="center"></el-table-column>
            <el-table-column prop="product_education" label="申请学位" align="center"></el-table-column>
            <el-table-column prop="product_cn_name" label="录取专业" align="center"></el-table-column>
          </el-table>
        </client-only>
      </div>
      <div class="item-rig">
        <img class="swiper-img" :src="advertisement.path" :alt="advertisement.name" @click="goHref(advertisement.href)">
      </div>
    </div>
    <div class="index-item">
      <div class="item-lf">
        <p class="lf-title">EDUHUNGARY严选</p>
        <div class="lf-choice">
          <div class="choice-swiper">
            <div class="choice-item">
              <p class="choice-list " :class="{'active': type === 5}" @click="checkoutType(5)">严选学校</p>
              <p class="choice-list" :class="{'active': type === 6}"   @click="checkoutType(6)">严选专业</p>
              <p class="choice-list" :class="{'active': type === 7}"  @click="checkoutType(7)">严选服务</p>
            </div>
            <div v-swiper:choiceSwiper="choiceOption" class="choice-container">
              <div class="swiper-wrapper choice-wrapper">
                <div class="swiper-slide choice-slide" v-for="(slide, index) in choiceList" :key="index">
                  <img class="choice-img" :src="slide.path" :alt="slide.name">
                </div>
              </div>
              <div class="choice-pagination"></div>
            </div>
          </div>
          <div class="lf-news">
            <div class="news-list">
              <p class="news-title">新闻与活动</p>
              <div class="news-text">
                <p class="text-self" v-for="(item, index) in newsList" :key="index" @click="goPage('/news/details',item.id)">{{ item.title }}</p>
                <p class="text-btn"><span class="btn-self" @click="goPage('/news')">查看更多</span></p>
              </div>
            </div>
            <div class="news-list">
              <p class="news-title">热门合作项目</p>
              <div class="news-text">
                <p class="text-self" v-for="(item, index) in hotTime" :key="index" @click="goPage('/hot/details',item.id)">{{ item.title }}</p>
                <p class="text-btn"><span class="btn-self" @click="goPage('/hot')">查看更多</span></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="item-rig">
        <p class="rig-major">热门申请专业 <span class="major-more" @click="goPage('/product')">查看更多</span> </p>
        <div class="rig-major-list">
          <p class="major-list-title">本科</p>
          <div class="major-list-info" v-for="(item, index) in benList" :key="index">
            <p class="info-num"><span class="num-self">00{{ index + 1 }}</span></p>
            <div class="info-text">
              <p class="text-self">{{ item.cn_name }}</p>
              <p class="text-self">{{ item.school_name }}</p>
            </div>
          </div>
        </div>
        <div class="rig-major-list">
          <p class="major-list-title">硕士</p>
          <div class="major-list-info" v-for="(item, index) in masterList" :key="index">
            <p class="info-num"><span class="num-self">00{{ index + 1 }}</span></p>
            <div class="info-text">
              <p class="text-self">{{ item.cn_name }}</p>
              <p class="text-self">{{ item.school_name }}</p>
            </div>
          </div>
        </div>
        <div class="rig-major-list">
          <p class="major-list-title">博士</p>
          <div class="major-list-info" v-for="(item, index) in boList" :key="index">
            <p class="info-num"><span class="num-self">00{{ index + 1 }}</span></p>
            <div class="info-text">
              <p class="text-self">{{ item.cn_name }}</p>
              <p class="text-self">{{ item.school_name }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="index-process">
      <p class="item-title">留学规划时间流程</p>
      <img class="process-img" src="~@/assets/images/index-process.png" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: 'IndexHome',
  data () {
    return {
      slideList: [],
      choiceList: [],
      swiperOption: {
        loop: true, // 循环模式
        slidesPerView: 'auto', // 解决loop模式下可能出现的空白问题[1](@ref)
        centeredSlides: true, // 幻灯片居中
        spaceBetween: 30, // 幻灯片之间的间距
        // 自动轮播
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        }
      },
      choiceOption: {
        loop: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 30,
        pagination: {
          el: '.choice-pagination',
          clickable: true
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        }
      },
      schoolsList: [],
      successCasesList: [],
      newsList: [],
      hotTime: [],
      benList: [],
      masterList: [],
      boList: [],
      type: 5,
      advertisement: {}, // 广告
      school_page: 1,
      school_total: 0,
    }
  },
  created () {
    this.getSchoolsList()
    this.getSuccessCasesList()
    this.getNewsList(0)
    this.getNewsList(1)
    this.getProductsList(7)
    this.getProductsList(9)
    this.getProductsList(10)
    this.getBanner()
    this.getAdvertisementLists()
  },
  methods: {
    previousSchools () { 
      if (this.school_page > 1) {
        this.school_page--
        this.getSchoolsList()
      } else {
        this.$message.warning('已经是第一页了')
      }
    },
    nextSchools () { 
      if (this.school_page < this.school_total) {
        this.school_page++
        this.getSchoolsList()
      } else {
        this.$message.warning('已经是最后一页')
      }
    },
    async getSchoolsList () { 
      try { 
        let res = await this.$api.get('schools?is_home=1&limit=6&page=' + this.school_page)
        if (res.code === 200 && res.data) {
          this.schoolsList = res.data
          this.school_total = res.total_pages
        }
      } catch (error) {}
    },
    async getSuccessCasesList () { 
      try {
        let res = await this.$api.get('successCases/lists?is_home=1')
        if (res.code === 200 && res.data) {
          this.successCasesList = res.data
        }
      } catch (error) {}
    },
    async getNewsList (type) { 
      try { 
        let res = await this.$api.get('news/lists?is_home=1&type=' + type)
        if (res.code === 200 && res.data) {
          if (type === 0) {
            this.newsList = res.data
          } else {
            this.hotTime = res.data
          }
        }
      } catch (error) {
      }
    },
    async getProductsList (id) { 
      try {
        let url = 'products/lists?is_home=1&education_id=' + id + '&is_hot=1' + '&home_position=2'
        let res = await this.$api.get(url)
        if (res.code === 200 && res.data) {
          if (id === 7) {
            this.benList = res.data
          } else if (id === 9) {
            this.masterList = res.data
          } else if (id === 10) {
            this.boList = res.data
          }
        }
      } catch (error) {
      }
    },
    checkoutType (type) {
      this.type = type
      this.getBanner()
    },
    // 获取广告
    async getAdvertisementLists () {
      try { 
        let res = await this.$api.get('advertisement/lists?platform=1&type=0')
        if (res.code === 200 && res.data) {
          this.advertisement = res.data ? res.data : {}
        }
      } catch (error) {}
    },
    // 获取轮播
    async getBanner () { 
      try { 
        let res = await this.$api.get('banners/lists?platform=1&type=' + this.type)
        if (res.code === 200 && res.data) {
          this.choiceList = res.data
        }
      } catch (error) {}
    },
    goPage (url, id) { 
      if (id) { 
        this.$router.push({
          path: url,
          query: {
            id: id
          }
        })
      } else { 
        this.$router.push(url)
      }
    },
    goHref (url) {
      if (url) {
        window.open(url, '_blank');
      }
    }
  }
}
</script>

<style scoped>
.admission-swiper{height:275px; }
.choice-container{height:340px;}
.home-index{padding:50px 0;}
.home-index ::v-deep .el-table th {color: #333;font-weight: 600;}
.swiper-img, .choice-img{display: block;width:100%;cursor:pointer;}
.index-item{display:flex;gap:40px;margin-bottom:40px;}
.index-item .item-lf{width:780px;}
.index-item .item-lf .lf-title{font-size:22px;color:#333;font-weight:600;line-height:2;margin-bottom:20px;display:flex;justify-content: space-between;align-items:center;}
.index-item .item-lf .lf-title .title-icons{display:flex;}
.index-item .item-lf .lf-title .lf-icon{display:block;width:24px;height:24px;background:url('~@/assets/images/index-more.png') center no-repeat;background-size:24px;cursor:pointer;}
.index-item .item-lf .lf-title .lf-icon.previous{transform:rotate(180deg);}
.index-item .item-lf .lf-list{display:flex;gap:30px;flex-wrap:wrap;}
/* .index-item .item-lf .lf-list .list-icon{position:absolute;top:50%;display:block;width:30px;height:30px;background:url('~@/assets/images/index-school-previous.png') center no-repeat;background-size:30px;cursor:pointer;opacity:0;transition:opacity .3s ease;transform:translate(0, -50%);}
.index-item .item-lf .lf-list:hover .list-icon{opacity:1;pointer-events:auto;}
.index-item .item-lf .lf-list .list-icon.previous{left:-10px;transform:translate(0, -50%) rotate(180deg);}
.index-item .item-lf .lf-list .list-icon.next{right:-10px;} */
.index-item .item-lf .lf-list .list-info{flex:1;min-width:calc(33.333% - 30px);box-shadow:0 0 2px 2px rgba(0,0,0,.05);cursor:pointer;align-self: flex-start;}
.index-item .item-lf .lf-list .list-img{display:block;width:84px;height:84px;margin:20px auto 14px;}
.index-item .item-lf .lf-list .list-text{padding:20px;font-size:14px;color:#333;background-color:#F8F8F8;}
.index-item .item-lf .lf-list .list-text .text-self{text-align:center;}
.index-item .item-lf .lf-list .list-text .text-self.te{height:42px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;}
.index-item .item-lf .lf-pagination{margin-top:20px;display:flex;justify-content:center;}
.index-item .item-lf .lf-pagination .pagination-btn{font-size:14px;padding:2px 10px;background-color:#198052;color:#fff;margin:0 10px;border-radius:5px;cursor:pointer;}
.index-item .item-rig{flex:1;}
.index-item .item-rig .rig-logo{padding-bottom:18px;margin-bottom:12px;border-bottom:1px solid rgba(212,48,48,.42);position:relative;}
.index-item .item-rig .rig-logo::after{content:'';position: absolute;left:0;bottom:-1.5px;display: block;width:2px;height:2px;background:#fff;border:1px solid rgba(212,48,48,.42);border-radius:2px;}
.index-item .item-rig .rig-logo::before{content:'';position: absolute;right:0;bottom:-1.5px;display: block;width:2px;height:2px;background:#fff;border:1px solid rgba(212,48,48,.42);border-radius:2px;}
.index-item .item-rig .logo-img{display:block;margin:0 auto;}
.index-item .item-rig .rig-text .text-self{font-size:14px;color:#333;line-height:2;margin-bottom:40px;}
.choice-container{width:100%;height:400px;position:relative;overflow:hidden;}
.choice-slide{text-align:center;}
.choice-pagination{position: absolute;bottom: 20px;left: 50%;transform: translateX(-50%);display: flex;gap: 20px;justify-content: center;}
.choice-item{display:flex;gap:40px;margin-bottom:20px;color:#333;font-size:16px;}
.choice-item .choice-list{cursor:pointer;}
.choice-item .choice-list.active{color:#198052;border-bottom:1px solid #198052;}
.lf-news{display:flex;margin-top:40px;}
.lf-news .news-list{width:50%;position:relative;padding:0 20px;}
.lf-news .news-list:first-child::after{content: '';position: absolute;right: 0;top: 0;bottom: 0;width: 1px;background-color: #e6e6e6;z-index: 1;}
.lf-news .news-title{font-size:22px;color:#333;font-weight:600;margin-bottom:20px;}
.lf-news .news-text{font-size:13px;color:#333;line-height:2;}
.lf-news .news-text .text-self{margin-bottom:8px;padding-left:20px;background:url('~@/assets/images/index-list.png') left center no-repeat;background-size:6px;white-space:nowrap;overflow: hidden;text-overflow: ellipsis;cursor:pointer;}
.lf-news .news-text .text-btn{overflow: hidden;}
.lf-news .news-text .text-btn .btn-self{float:right;display:block;padding:8px 12px;background-color:#198052;color:#fff;font-size:14px;line-height:1;border-radius:4px;cursor:pointer;}
.rig-major{font-size:22px;display:flex;justify-content:space-between;color:#333;font-weight:600;}
.rig-major .major-more{font-size:14px;background-color:#198052;font-weight:100;line-height:30px;height:30px;padding:0 12px;color:#fff;border-radius:4px;cursor:pointer;}
.rig-major-list{margin-top:30px;border-bottom:1px solid #e6e6e6;}
.rig-major-list:last-child{border-bottom:none;}
.rig-major-list .major-list-title{font-size:16px;font-weight:600;margin-bottom:10px;}
.rig-major-list .major-list-info{display:flex;gap:20px;margin-bottom:20px;}
.rig-major-list .major-list-info .info-num{font-size:14px;color:#fff;display:block;}
.rig-major-list .major-list-info .info-num .num-self{padding:0 8px;background-color:#E3343E;line-height:28px;display:block;}
.rig-major-list .major-list-info .info-text{font-size:14px;}
.rig-major-list .major-list-info .info-text .text-self{margin-bottom:5px;}
.index-process{margin-top:40px;}
.index-process .item-title{font-size:22px;font-weight:600;margin-bottom:20px;}
.index-process .process-img{display:block;margin: 0 auto;}
</style>